import styled from "styled-components";

const CompanyErrorScreen = ({errorText}) => {
  return (
    <Wrapper>
      <div className="content">
        <div className="spinner">⚠️</div>
        <h4>Application Error</h4>
        <p className="status-text">{`${
          errorText?.statusText ?? "Something went wrong. Please try again"
        }`}</p>
      </div>
    </Wrapper>
  );
};

export default CompanyErrorScreen;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.background};
  width: 100vw;
  height: 100vh;
  .content {
    position: absolute;
    top: 25%;
    left: 30%;
    width: 576px;
    height: 324px;
    background-color: ${({ theme }) => theme.widget.background};
    padding: 6rem 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .spinner {
      margin-bottom: 10px;
    }
    .status-text {
      margin-top: 10px;
      font-weight: 300;
      font-size: 16px;
    }
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
  }
`;
